<template>
  <span class="icon" :class="domclass">
    <svg><use :xlink:href="imgUrl"></use></svg>
  </span>
</template>

<script setup lang="ts">
import { ref, inject } from 'vue'

const props = defineProps({
  domclass: {
    type: String,
    default () {
      return ''
    }
  },
  image: {
    type: String,
    required: true
  }
})

const options : Record<string, any> | undefined = inject('libraryOptions')
const path = options?.spritepath
const imgUrl = ref(`${path}#${props.image}`)

</script>
